import { render, staticRenderFns } from "./LogoUpdate.vue?vue&type=template&id=43331bb3"
import script from "./LogoUpdate.vue?vue&type=script&lang=js"
export * from "./LogoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports